export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    categories: [],
    croppingImage: null,
    showCropper: false,
    croppingModel: null,
    types: [
      {
        value: '0',
        label: 'Selecione um tipo'
      },
      {
        value: '1',
        label: 'Nacional'
      },
      {
        value: '2',
        label: 'Internacional'
      }
    ],
    place: {
      name: '',
      description: '',
      type: '',
      categories: [],
      cover: '',
      featuredImage: ''
    }
  }
}
